import React from 'react';
import propTypes from 'prop-types';
import './Toolbox.scss';
import HowItWorks from './HowItWorks';
import ToolboxButtons from './ToolboxButtons';
import ProgressIndicator from './Progress';
import InProgressButtons from './InProgressButtons';

class Toolbox extends React.Component {
	render() {
		return (
			<div className="ws-dr-toolbox digital-retailing-toolbox">
				<HowItWorks
					deviceType={this.props.deviceType}
					widgetClasses={this.props.widgetClasses}
				/>
				{this.props.deviceType === 'DESKTOP' && <ProgressIndicator />}
				<InProgressButtons />
				<ToolboxButtons {...this.props} />
			</div>
		);
	}
}

Toolbox.propTypes = {
	deviceType: propTypes.string,
	widgetClasses: propTypes.string
};

Toolbox.defaultProps = {
	deviceType: 'DESKTOP',
	widgetClasses: ''
};

export default Toolbox;



// WEBPACK FOOTER //
// ./src/components/Toolbox.jsx